import { Pipe, PipeTransform } from '@angular/core';
import { EXPERT_TIME_REGEX } from '@concretecode/shared';

@Pipe({
  name: 'timeOfExpertTime',
})
export class TimeOfExpertTimePipe implements PipeTransform {
  transform(value: string): string {
    if (!value || !EXPERT_TIME_REGEX.test(value)) {
      return '';
    }

    const parts = value.split(':');
    const hours = parts[1].substring(0, 2);
    const minutes = parts[1].substring(2, 4);

    return `${hours}:${minutes}`;
  }
}
